import { PageContent } from "@redriver/cinnamon";
import { DealerDetails } from "features/Dealers";
import React from "react";
import { AppRoutes } from "constants/routes";
import { RedirectBreadcrumbBar } from "pages/nav";

const DealerDetailsPage = ({ match }) => (
  <PageContent fluid>
    <RedirectBreadcrumbBar to={AppRoutes.Dealers} text="Back to Suppliers" />
    <DealerDetails dealerId={match.params.id} />
  </PageContent>
);

export default DealerDetailsPage;
